import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Mixins, Watch } from "vue-property-decorator";
// SYSTEM1
import Loader from "@/components/widgets/loader.vue";
import Layout from "@/router/layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import simplebar from "simplebar-vue";
import { PAReviewModule } from "@/store/modules/paReview.module";
import ReviewComponent from "./components/ReviewComponent.vue";
import { interpret } from "xstate";
import clientInteractionMachine from "./machines/clientInteractionMachine";
import ClientEmailTemplate from "./components/ClientEmailTemplate.vue";
import Switches from "vue-switches";
let AMOverview = /** @class */ (() => {
    let AMOverview = class AMOverview extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.title = "Review Overview";
            this.items = [
                {
                    text: "Home",
                    to: "/dashBoard",
                },
                {
                    text: "Performance",
                },
                {
                    text: "Reviews",
                    to: "/performance/reviews",
                },
                {
                    text: "Review Overview",
                    active: true,
                },
            ];
            this.ctaButtons = [
                {
                    routeName: "ReviewListing",
                },
            ];
            this.pageIsLoading = true;
            this.isClientCellClicked = false;
            this.clientCellLabel = "Select Client";
            this.cycleId = "";
            this.stepId = "";
            this.Link = "";
            this.assignmentsToSave = [];
            //   MACHINE
            this.machine = clientInteractionMachine;
            this.machineService = interpret(this.machine, { devTools: true });
            this.state = this.machine.initialState;
        }
        send(event) {
            this.machineService.send(event);
        }
        openReview(reviewId) {
            let reviewComponent = this.$refs["reviewComponentRef"];
            reviewComponent.ShowReviewModal(reviewId, this.stepId);
        }
        showClientAssignments() {
            this.showClientEmailTemplateModal();
        }
        saveClientAssignments(content) {
            const assignments = [...this.assignmentsToSave];
            this.assignmentsToSave = [];
            this.send({ type: "SAVE_ASSIGNMENTS", assignments: assignments, customizedContent: content });
        }
        clearClientAssignments() {
            this.assignmentsToSave = [];
        }
        nudge(assignment) {
            this.send({ type: "SEND_NUDGE_MAIL", assignment: assignment });
        }
        reviewModalClosing() {
            this.send({ type: "REVIEW_MODAL_CLOSING" });
        }
        showClientEmailTemplateModal() {
            let clientEmailTemplate = this.$refs["client-email-template"];
            clientEmailTemplate.showModal();
        }
        get clientInteractionDetails() {
            return PAReviewModule.clientInteractionDetails;
        }
        get reviewTotalCount() {
            return this.clientInteractionDetails.reviewDetailsCount;
        }
        autoNudge(contactId, autoNudge) {
            this.send({ type: "UPDATING_AUTO_NUDGE", contactId: contactId, autoNudge: autoNudge });
        }
        get nudgeHistory() {
            return PAReviewModule.clientNudgeHistory;
        }
        disabledClientContacts(assignment) {
            if (assignment.readyForAssignment) {
                var isAssignedAlready = this.clientInteractionDetails.clientContacts.some((x) => x.clientContactAssignments.some((y) => y.employeeId == assignment.employeeId && y.isAssigned && y.id != assignment.id));
                if (isAssignedAlready || this.assignmentsToSave.some((x) => x.employeeId == assignment.employeeId && x.id != assignment.id)) {
                    const element = document.getElementById(`c-${assignment.id}`);
                    if (element) {
                        return true;
                    }
                }
                return false;
            }
            return false;
        }
        assignmentsToSaveChanged() {
            this.clientInteractionDetails.clientContacts.forEach((client) => {
                client.clientContactAssignments.forEach((assignment) => {
                    if (assignment.readyForAssignment) {
                        var isAssignedAlready = this.clientInteractionDetails.clientContacts.some((x) => x.clientContactAssignments.some((y) => y.employeeId == assignment.employeeId && y.isAssigned && y.id != assignment.id));
                        if (isAssignedAlready || this.assignmentsToSave.some((x) => x.employeeId == assignment.employeeId && x.id != assignment.id)) {
                            const element = document.getElementById(`c-${assignment.id}`);
                            if (element) {
                                element.classList.add("assignment-disabled");
                            }
                        }
                        else {
                            const element = document.getElementById(`c-${assignment.id}`);
                            if (element) {
                                element.classList.remove("assignment-disabled");
                            }
                        }
                    }
                });
            });
        }
        created() {
            this.cycleId = this.$route.params.cycleId;
            this.stepId = this.$route.params.stepId;
            this.send({ type: "GETTING_REVIEWS", cycleId: this.$route.params.cycleId, stepId: this.$route.params.stepId });
            this.machineService.start();
            this.machineService.onTransition((state) => {
                var previousState = this.state;
                this.state = state;
                if (previousState.matches("savingAssignments") && this.state.matches("gettingReviews")) {
                    let clientEmailTemplate = this.$refs["client-email-template"];
                    clientEmailTemplate.close();
                }
            });
        }
    };
    __decorate([
        Watch("assignmentsToSave"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AMOverview.prototype, "assignmentsToSaveChanged", null);
    AMOverview = __decorate([
        Component({
            name: "AMOverview",
            components: {
                Layout,
                PageHeader,
                Loader,
                simplebar,
                Switches,
                ReviewComponent,
                ClientEmailTemplate,
            },
        })
    ], AMOverview);
    return AMOverview;
})();
export default AMOverview;
